import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-767799d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "input-wapper d-flex" }
const _hoisted_3 = {
  key: 1,
  class: "error-msg"
}

import { withDefaults, ref, watch, onMounted } from 'vue';
import { Money3Component } from 'v-money3';

interface IProps {
  modelValue?: any;
  msgError?: string;
  prefix?: string;
  suffix?: string;
  label?: string;
  decimal?: string;
  min?: number;
  max?: number;
  thousands?: string;
  placeholder?: string;
  prependIcon?: boolean;
  required?: boolean;
  width?: string;
  noBgPrependIcon?: boolean;
  noBorderPrependIcon?: boolean;
  hasError?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomInputMoney',
  props: {
    modelValue: {},
    msgError: { default: '' },
    prefix: { default: 'R$' },
    suffix: { default: '' },
    label: {},
    decimal: { default: ',' },
    min: {},
    max: {},
    thousands: { default: '.' },
    placeholder: {},
    prependIcon: { type: Boolean },
    required: { type: Boolean },
    width: { default: '346px' },
    noBgPrependIcon: { type: Boolean, default: false },
    noBorderPrependIcon: { type: Boolean, default: false },
    hasError: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "6ed719ab": (_ctx.maxWidth)
}))

const props = __props;

const amount = ref(0);
const config = ref({
  masked: false,
  prefix: props.prefix,
  suffix: props.suffix,
  thousands: props.thousands,
  decimal: props.decimal,
  precision: 2,
  disableNegative: false,
  disabled: false,
  min: props.min,
  max: props.max,
  allowBlank: true,
  // minimumNumberOfCharacters: 0,
});

const emit = __emit;
watch(
  () => amount.value,
  () => {
    emit('update:modelValue', amount.value);
  }
);
onMounted(() => {
  amount.value = props.modelValue ?? 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.prependIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([{ 'bg-gray-06': !_ctx.noBgPrependIcon, 'border-e': !_ctx.noBorderPrependIcon,  }, "prependIcon h-100 px-2 d-flex align-center"])
          }, [
            _renderSlot(_ctx.$slots, "prependIcon")
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_unref(Money3Component), _mergeProps({
        required: props.required,
        class: "input",
        modelValue: amount.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
        placeholder: props.placeholder
      }, config.value), null, 16, ["required", "modelValue", "placeholder"])
    ]),
    (_ctx.hasError && _ctx.msgError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.msgError), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})